import { useState } from 'react';
import Table from '../Listing/Table';
import Modal from '../Modal/Modal';
import SendInvoiceEmailModal from '../Modal/SendInvoiceEmailModal';
import { Document, Page, pdfjs } from 'react-pdf';
import useInvoiceColumns from '../../hooks/invoiceColumns';

import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const OrderInvoices = ({
    invoices
}) => {
    const [error, setError] = useState(null);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState('desc');
    const [keyword, setKeyword] = useState("");

    const [pdfData, setPdfData] = useState(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [emailTarget, setEmailTarget] = useState(null);

    // Same shared column set as the main /invoices listing (badges, patient avatar,
    // amount styling, actions menu) — orderNumber/patientId are dropped since every
    // row here already belongs to this one order and its one patient.
    const columns = useInvoiceColumns({
        setPdfData,
        setShowPdfModal,
        setPageNumber,
        setEmailTarget,
        excludeColumns: ['orderNumber', 'patientId'],
    });

    if (error) {
        return <div>{error}</div>;
    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <>
            <Table
                mode="client"
                columns={columns}
                data={invoices}
                emptyMessage="Aucune facture"
                onSort={(field) => {
                    setSortField(field);
                    setSortDirection((prev) => (sortField === field && prev === 'asc' ? 'desc' : 'asc'));
                }}
                sortField={sortField}
                sortDirection={sortDirection}
                totalElements={invoices.length}
                multiSelect={true}
                keyword={keyword}
                setKeyword={setKeyword}
            />

            <Modal title="Visualisation de la facture PDF" show={showPdfModal} onClose={() => setShowPdfModal(false)} classSize="modal-lg">
                {pdfData ? (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Document
                                file={pdfData}
                                onLoadSuccess={onDocumentLoadSuccess}
                            >
                                <Page pageNumber={pageNumber} width={680} />
                            </Document>
                        </div>

                        {numPages > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    disabled={pageNumber <= 1}
                                    onClick={() => setPageNumber(pageNumber - 1)}
                                >
                                    Précédent
                                </button>
                                <span className="text-muted small">Page {pageNumber} / {numPages}</span>
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    disabled={pageNumber >= numPages}
                                    onClick={() => setPageNumber(pageNumber + 1)}
                                >
                                    Suivant
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center py-4 text-muted">Chargement du PDF...</div>
                )}
            </Modal>

            <SendInvoiceEmailModal invoice={emailTarget} onClose={() => setEmailTarget(null)} />
        </>
    );
};

export default OrderInvoices;
